/* eslint-disable */
import {
  AccordionActions,
  createStyles,
  Divider,
  Theme,
  withStyles,
} from "@material-ui/core";
import {
  Button as ButtonMat,
  Select as SelectMultiple,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { FormControl, FormLabel, HStack, Select } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DropzoneArea } from "material-ui-dropzone";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  getAllEmailTemplates,
  getEmailTemplateByType,
  addEmailTemplateByType,
} from "../../../utils/store/actions/users.actions";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzoneEmail: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    previewChip: {
      width: "100px",
      maxWidth: "300px",
      color: "#ae0064",
    },
  });

  interface State extends Record<string, any> {
    availableLanguages: string[];
  }

class EmailTemplateConfiguration extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      emailTemplateFilesFr: "",
      emailTemplateFilesEn: "",
      emailTemplateFilesEs: "",
      emailTemplateFilesIt: "",
      emailTemplateFilesNl: "",
      availableLanguages: []
    };
  }
  async componentDidMount() {
    await this.props.getAllEmailTemplates();

    const languages = this.props.Users?.availableLanguages as AvailableLanguageDTO[] || [];
    const selectedLanguages = languages.filter(lang => lang.isSelected).map(lang => lang.languageCode);

    this.setState({ availableLanguages: selectedLanguages });
  }

  // HANDLE EMAIL TEMPLATES
  handleEmailTemplate(e: any) {
    this.setState({ emailTemplate: e.target.value });
  }
  handleEmailTemplateDownload(template: any, language: any) {
    this.props.getEmailTemplateByType(template, language).then(() => {
      let filename = template;
      var element = document.createElement("a");
      filename = this.props.Users.email_template_by_type;
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(filename)
      );
      element.setAttribute("download", `emailTemplate-${language}.ftl`);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  }
  handleChangeEmailTemplateEn(emailTemplateFiles: any) {
    this.setState({ emailTemplateEn: emailTemplateFiles[0] });
    const file: any = new FormData();
    file.append("file", emailTemplateFiles[0]);
    this.setState({
      emailTemplateFilesEn: file,
    });
  }
  handleChangeEmailTemplateFr(emailTemplateFiles: any) {
    this.setState({ emailTemplateFr: emailTemplateFiles[0] });
    const file: any = new FormData();
    file.append("file", emailTemplateFiles[0]);
    this.setState({
      emailTemplateFilesFr: file,
    });
  }
  handleChangeEmailTemplateEs(emailTemplateFiles: any) {
    this.setState({ emailTemplateEs: emailTemplateFiles[0] });
    const file: any = new FormData();
    file.append("file", emailTemplateFiles[0]);
    this.setState({
      emailTemplateFilesEs: file,
    });
  }
  handleChangeEmailTemplateIt(emailTemplateFiles: any) {
    this.setState({ emailTemplateIt: emailTemplateFiles[0] });
    const file: any = new FormData();
    file.append("file", emailTemplateFiles[0]);
    this.setState({
      emailTemplateFilesIt: file,
    });
  }
  handleChangeEmailTemplateNl(emailTemplateFiles: any) {
    this.setState({ emailTemplateNl: emailTemplateFiles[0] });
    const file: any = new FormData();
    file.append("file", emailTemplateFiles[0]);
    this.setState({
      emailTemplateFilesNl: file,
    });
  }

  uploadEmailTemplates() {
    if (this.state.emailTemplateEn) {
      this.props.addEmailTemplateByType(
        this.state.emailTemplateFilesEn,
        this.state.emailTemplate,
        "en"
      );
    }
    if (this.state.emailTemplateFr) {
      this.props.addEmailTemplateByType(
        this.state.emailTemplateFilesFr,
        this.state.emailTemplate,
        "fr"
      );
    }
    if (this.state.emailTemplateEs) {
      this.props.addEmailTemplateByType(
        this.state.emailTemplateFilesEs,
        this.state.emailTemplate,
        "es"
      );
    }
    if (this.state.emailTemplateIt) {
      this.props.addEmailTemplateByType(
        this.state.emailTemplateFilesIt,
        this.state.emailTemplate,
        "it"
      );
    }
    if (this.state.emailTemplateNl) {
      this.props.addEmailTemplateByType(
        this.state.emailTemplateFilesNl,
        this.state.emailTemplate,
        "nl"
      );
    }
  }

  render() {
    const { classes, Funds, t } = this.props;
    const { availableLanguages } = this.state;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="emailTemplates"
        >
          <Typography className={classes.heading}>
            {t("EMAIL_TEMPLATES")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            <FormControl id="emailTemplates" isRequired>
              <FormLabel>{t("Templates")}</FormLabel>
              <HStack style={{ marginBottom: "5px" }}>
                <Select
                  onChange={(e: any) => this.handleEmailTemplate(e)}
                  id="emailTemplatesSelect"
                  placeholder={t("CHOOSE_TEMPLATES")}
                >
                  {this.props.Users.email_templates?.map((f: any) => (
                    <option key={f} value={f}>
                      {t(f)}
                    </option>
                  ))}
                </Select>
              </HStack>
            </FormControl>
            <div>
              {this.state.emailTemplate && (
                <>
                  <div style={{ display: "flex" }}>
                    {availableLanguages.includes("en") && (
                      <div style={{ margin: "5px" }}>
                        <ListItem>
                          <ListItemText primary={t("DOWNLOAD")} />
                          <div>
                            <span>EN</span>{" "}
                            <GetAppIcon
                              onClick={() =>
                                this.handleEmailTemplateDownload(
                                  this.state.emailTemplate,
                                  "en"
                                )
                              }
                            />
                          </div>
                        </ListItem>
                        <DropzoneArea
                          dropzoneClass={classes.dropzoneEmail}
                          showFileNames
                          showPreviews={true}
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{
                            container: {
                              spacing: 1,
                              direction: "row",
                            },
                          }}
                          previewChipProps={{
                            classes: { root: classes.previewChip },
                          }}
                          previewText="File:"
                          // acceptedFiles={["text/html"]}
                          dropzoneText={t("ftl")}
                          filesLimit={1}
                          onChange={this.handleChangeEmailTemplateEn.bind(this)}
                        />
                      </div>
                    )}
                    {availableLanguages.includes("fr") && (
                      <div style={{ margin: "5px" }}>
                        <ListItem>
                          <ListItemText primary={t("DOWNLOAD")} />
                          <div>
                            <span>FR</span>{" "}
                            <GetAppIcon
                              onClick={() =>
                                this.handleEmailTemplateDownload(
                                  this.state.emailTemplate,
                                  "fr"
                                )
                              }
                            />
                          </div>
                        </ListItem>
                        <DropzoneArea
                          dropzoneClass={classes.dropzoneEmail}
                          showFileNames
                          showPreviews={true}
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{
                            container: { spacing: 1, direction: "row" },
                          }}
                          previewChipProps={{
                            classes: { root: classes.previewChip },
                          }}
                          previewText="File:"
                          // acceptedFiles={["text/ftl"]}
                          dropzoneText={t("ftl")}
                          filesLimit={1}
                          onChange={this.handleChangeEmailTemplateFr.bind(this)}
                        />
                      </div>
                    )}
                    {availableLanguages.includes("es") && (
                      <div style={{ margin: "5px" }}>
                        <ListItem>
                          <ListItemText primary={t("DOWNLOAD")} />
                          <div>
                            <span>ES</span>{" "}
                            <GetAppIcon
                              onClick={() =>
                                this.handleEmailTemplateDownload(
                                  this.state.emailTemplate,
                                  "es"
                                )
                              }
                            />
                          </div>
                        </ListItem>
                        <DropzoneArea
                          dropzoneClass={classes.dropzoneEmail}
                          showFileNames
                          showPreviews={true}
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{
                            container: { spacing: 1, direction: "row" },
                          }}
                          previewChipProps={{
                            classes: { root: classes.previewChip },
                          }}
                          previewText="File:"
                          // acceptedFiles={["text/ftl"]}
                          dropzoneText={t("ftl")}
                          filesLimit={1}
                          onChange={this.handleChangeEmailTemplateEs.bind(this)}
                        />
                      </div>
                    )}
                    {availableLanguages.includes("it") && (
                      <div style={{ margin: "5px" }}>
                        <ListItem>
                          <ListItemText primary={t("DOWNLOAD")} />
                          <div>
                            <span>IT</span>{" "}
                            <GetAppIcon
                              onClick={() =>
                                this.handleEmailTemplateDownload(
                                  this.state.emailTemplate,
                                  "it"
                                )
                              }
                            />
                          </div>
                        </ListItem>
                        <DropzoneArea
                          dropzoneClass={classes.dropzoneEmail}
                          showFileNames
                          showPreviews={true}
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{
                            container: { spacing: 1, direction: "row" },
                          }}
                          previewChipProps={{
                            classes: { root: classes.previewChip },
                          }}
                          previewText="File:"
                          // acceptedFiles={["text/ftl"]}
                          dropzoneText={t("ftl")}
                          filesLimit={1}
                          onChange={this.handleChangeEmailTemplateIt.bind(this)}
                        />
                      </div>
                    )}
                    {availableLanguages.includes("nl") && (
                      <div style={{ margin: "5px" }}>
                        <ListItem>
                          <ListItemText primary={t("DOWNLOAD")} />
                          <div>
                            <span>NL</span>{" "}
                            <GetAppIcon
                              onClick={() =>
                                this.handleEmailTemplateDownload(
                                  this.state.emailTemplate,
                                  "nl"
                                )
                              }
                            />
                          </div>
                        </ListItem>
                        <DropzoneArea
                          dropzoneClass={classes.dropzoneEmail}
                          showFileNames
                          showPreviews={true}
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{
                            container: { spacing: 1, direction: "row" },
                          }}
                          previewChipProps={{
                            classes: { root: classes.previewChip },
                          }}
                          previewText="File:"
                          dropzoneText={t("ftl")}
                          filesLimit={1}
                          onChange={this.handleChangeEmailTemplateNl.bind(this)}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </List>
        </AccordionDetails>
        {this.state.emailTemplate && (
          <>
            <Divider />
            <AccordionActions>
              <ButtonMat
                disabled={this.state.emailTemplate === ""}
                size="small"
                style={{ color: "#ae0064" }}
                onClick={() => {
                  this.uploadEmailTemplates();
                }}
              >
                {t("SAVE")}
              </ButtonMat>
            </AccordionActions>
          </>
        )}
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllEmailTemplates,
  getEmailTemplateByType,
  addEmailTemplateByType,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(EmailTemplateConfiguration)));
